<template>
  <div class="dashboard__view">
    <div class="page">
      <div class="page__title">Transfers</div>
    </div>

    <div @click="$router.go(-1)" class="page__nav">
      <div class="page__nav__icon">
        <svg fill="none" height="16" viewBox="0 0 19 16" width="19" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 7L4.92969 7L9.5 2.42969L8 0.929687L0.929687 8L8 15.0703L9.5 13.5703L4.92969 9L19 9L19 7Z"
            fill="#655D79" />
        </svg>
      </div>
      <div class="page__nav__text">Transfer Details</div>
    </div>

    <div class="row w-100">
      <div class="col-md-6">
        <div class="details__card w-100" v-if="loadingTransaction">
          <div class="details__card__container p-5">
            <div class="my-5">
              <ListLoader></ListLoader>
            </div>
            <div class="my-5">
              <ListLoader></ListLoader>
            </div>
          </div>
        </div>

        <div class="details__card" v-else>
          <div class="details__card__container">
            <div class="details__card__header pl-3 pr-0">
              <div class="d-flex mb-3" v-if="!transferDetails.transactionStatus">
                <h1 class="mr-2">Approval:</h1>
                <h1>
                  <status-indicator-with-words :type="transferDetails.requestStatus" />
                </h1>
              </div>

              <div class="flex items-center ">
                <div class="row align-items-center m-0">
                  <div class="col-auto p-0" v-if="transferDetails.transactionStatus">
                    <StatusIndicator :type="transferDetails.transactionStatus" />
                  </div>
                  <div class="col-auto p-0">
                    <h3>{{ transferDetails.transactionReference }}</h3>
                  </div>

                  <div class="col-auto p-0 ml-2">
                    <button v-if="transferDetails.transactionStatus === 'SUCCESSFUL'" class="download_btn"
                      @click="downloadTransfersReceipt" :disabled="downloading">
                      {{ downloading ? 'Downloading...' : 'Download Receipt' }}
                    </button>

                  </div>
                </div>
              </div>
            </div>

            <div class="details__card__item border-none pt-2">
              <div class="details__card__item__left">
                <div class="details__card__item__label">Amount</div>
                <div class="details__card__item__value">
                  <h1>₦{{ transferDetails.amount | money }}</h1>
                </div>
              </div>
            </div>

            <div class="details__card__item">
              <div class="details__card__item__left">
                <div class="details__card__item__label">Source Bank</div>
                <div class="details__card__item__value">
                  {{ transferDetails.sourceBankName | availability }}
                </div>
              </div>
              <div class="details__card__item__right">
                <div class="details__card__item__label">Source Account</div>
                <div class="details__card__item__value">
                  {{ transferDetails.sourceAccountNumber | availability }}
                </div>
              </div>
            </div>
            <div class="details__card__item">
              <div class="details__card__item__left">
                <div class="details__card__item__label">Destination Bank</div>
                <div class="details__card__item__value">
                  {{ transferDetails.destinationBankName | availability }}
                </div>
              </div>
              <div class="details__card__item__right">
                <div class="details__card__item__label">
                  Destination Account
                </div>
                <div class="details__card__item__value">
                  {{ transferDetails.destinationAccountNumber | availability }}
                </div>
              </div>
            </div>

            <div class="details__card__item">
              <div class="details__card__item__left">
                <div class="details__card__item__label">Requester</div>
                <div class="details__card__item__value">
                  {{ transferDetails.requesterEmail | availability }}
                </div>
              </div>
              <div class="details__card__item__right">
                <div class="details__card__item__label">Amount</div>
                <div class="details__card__item__value">
                  ₦{{ transferDetails.amount | money }}
                </div>
              </div>
            </div>

            <div class="details__card__item" v-if="transferDetails.status !== 'PENDING'">
              <div class="details__card__item__left">
                <div class="details__card__item__label">Approve Name</div>
                <div class="details__card__item__value">
                  {{ transferDetails.approverName | availability }}
                </div>
              </div>
              <div class="details__card__item__right">
                <div class="details__card__item__label">Approve Email</div>
                <div class="details__card__item__value">
                  {{ transferDetails.approverEmail | availability }}
                </div>
              </div>
            </div>

            <div class="details__card__item">
              <div class="details__card__item__left">
                <div class="details__card__item__label">Narration</div>
                <div class="details__card__item__value">
                  {{
                    (transferDetails.narration || transferDetails.comment)
                    | availability
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--  timeline -->
      <div class="col-md-6" v-if="loadingTransaction">
        <div class="details__card w-100">
          <div class="details__card__container">
            <div class="details__trail w-100 m-0">
              <div class="details__trail__header">Transaction Logs</div>
              <div class="px-4 py-2">
                <BulletListLoader></BulletListLoader>
                <BulletListLoader></BulletListLoader>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6" v-else>
        <div class="details__card w-100">
          <div class="details__card__container p-0">
            <div class="details__trail w-100 m-0">
              <div class="details__trail__header">
                <div class="row m-0 justify-content-center align-items-center">
                  <div class="col">Transfer Timeline</div>
                </div>
              </div>
              <div class="timeline p-4 block mb-4">
                <div class="tl-item active">
                  <div class="tl-dot b-danger"></div>
                  <div class="tl-content">
                    <div class="h4">Requested Date</div>
                    <div class="tl-date text-muted mt-1 h5">
                      {{
                        moment(
                          transferDetails.createdAt
                            ? transferDetails.createdAt
                            : ""
                        ).format("llll")
                      }}
                    </div>
                  </div>
                </div>
                <div class="tl-item active" v-if="transferDetails.requestStatus !== 'PENDING'">
                  <div class="tl-dot b-danger"></div>
                  <div class="tl-content">
                    <div class="h4">Approval Date</div>
                    <div class="tl-date text-muted mt-1 h5">
                      {{
                        moment(
                          transferDetails.approvalDate
                            ? transferDetails.approvalDate
                            : ""
                        ).format("llll")
                      }}
                    </div>
                  </div>
                </div>
                <div class="tl-item active" v-if="transferDetails.transactionStatus == 'SUCCESSFUL'">
                  <div class="tl-dot b-primary"></div>
                  <div class="tl-content">
                    <div class="h4">Transaction Date</div>
                    <div class="tl-date text-muted mt-1 h5">
                      {{
                        moment(
                          transferDetails.updatedAt
                            ? transferDetails.updatedAt
                            : ""
                        ).format("llll")
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--</div>-->
</template>

<script>
import { reactive, onBeforeMount, toRefs, ref } from "@vue/composition-api";
import { ListLoader, BulletListLoader } from "vue-content-loader";
import StatusIndicator from "../../../components/status-indicator";
import StatusIndicatorWithWords from "../../../components/statusIndicatorWithWords";

export default {
  metaInfo: {
    title: "Transfer Details",
  },

  components: {
    StatusIndicatorWithWords,
    StatusIndicator,
    ListLoader,
    BulletListLoader,
  },

  setup(props, { root }) {
    const store = root.$store;
    const data = reactive({
      loadingTransaction: false,
      transferDetails: {},
      audit: "",
    });

    const downloading = ref(false);

    const downloadTransfersReceipt = () => {
      downloading.value = true; // Show "Downloading..." immediately

      const data = {
        transactionId: root.$route.params.reference,
        transactionType: "admin-transfer",
      };

      root.$http.post("admin/receipts/generate", data)
        .then(response => {
          if (response.body && response.body.data && response.body.data.url) {
            window.open(response.body.data.url, "_blank");
          } else {
            root.$notify({
              group: "notifications-default",
              type: "error text-white",
              title: "Error",
              text: "Invalid receipt URL received",
            });
          }
        })
        .catch(error => {
          root.$notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: (error.body && error.body.message)
              ? error.body.message
              : "Failed to generate receipt",
          });
        })
        .finally(() => {
          downloading.value = false; // Hide "Downloading..." after request completes
        });
    };


    //mounted
    onBeforeMount(() => {
      if (!root.$route.params.reference)
        root.$router.push(
          "/dashboard/transfers?page=1&request_status=APPROVED"
        );
      fetchTransferDetails();

    });

    //methods
    const fetchTransferDetails = async () => {
      data.loadingTransaction = true;
      const response = await store.dispatch(
        "getTransferDetails",
        root.$route.params.reference
      );
      if (response) {
        data.transferDetails = response;
      }
      data.loadingTransaction = false;
    };



    return {
      ...toRefs(data),
      moment,
      downloadTransfersReceipt,
      downloading,
    };
  },
};
</script>

<style scoped>
h3 {
  color: #261940 !important;
  font-size: 20px !important;
  font-weight: 400 !important;
}

.details__card {
  width: 100%;
}

.details__card__container {
  box-shadow: none !important;
  border-radius: 4px;
  border: 0;
}

h1 {
  color: #261940 !important;
  font-size: 24px !important;
  font-weight: 400 !important;
}

.details__card__item {
  border-top: 1px solid rgb(235 240 244 / 50%);
}

.details.transaction .details__card__header {
  border: 0 !important;
}

.details.transaction .details__card__container {
  padding: 1rem;
}

.tl-item .avatar {
  z-index: 2;
}

.timeline {
  position: relative;
  border-color: rgba(160, 175, 185, 0.15);
  padding: 0;
  margin: 0;
}

.tl-item {
  border-radius: 3px;
  position: relative;
  display: -ms-flexbox;
  display: flex;
}

.tl-item>* {
  padding: 10px;
}

.tl-item .avatar {
  z-index: 2;
}

.tl-item:last-child .tl-dot:after {
  display: none;
}

.tl-item:last-child .tl-dot:after {
  display: none;
}

.tl-dot {
  position: relative;
  border-color: rgba(160, 175, 185, 0.15);
}

.tl-dot:after,
.tl-dot:before {
  content: "";
  position: absolute;
  border-color: inherit;
  border-width: 2px;
  border-style: solid;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
}

.tl-dot:after {
  width: 0;
  height: auto;
  top: 25px;
  bottom: -15px;
  border-right-width: 0;
  border-top-width: 0;
  border-bottom-width: 0;
  border-radius: 0;
}

.tl-item.active .tl-dot.b-primary:before {
  background-color: rgba(21, 206, 154, 0.7);
}

.tl-item.active .tl-dot.b-warning:before {
  background-color: rgba(255, 175, 11, 1);
}

.tl-item.active .tl-dot.b-danger:before {
  background-color: rgba(198, 16, 16, 0.7);
}

/* .tl-item.active .tl-dot:before {
    background-color: #448bff;
} */
.tl-dot {
  position: relative;
  border-color: rgba(160, 175, 185, 0.15);
}

.tl-dot:after,
.tl-dot:before {
  content: "";
  position: absolute;
  border-color: inherit;
  border-width: 2px;
  border-style: solid;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
}

.tl-dot:after {
  width: 0;
  height: auto;
  top: 25px;
  bottom: -15px;
  border-right-width: 0;
  border-top-width: 0;
  border-bottom-width: 0;
  border-radius: 0;
}

.tl-content p:last-child {
  margin-bottom: 0;
}

.tl-date {
  font-size: 0.85em;
  margin-top: 2px;
  min-width: 100px;
}

.h4 {
  font-size: 16px;
}

.h5 {
  font-size: 14px;
}

.w-100 {
  width: 100%;
}

.download_btn {
  font-family: Lato;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  background-color: white;
  border-radius: 6px;
  border: 1px solid #e00b5b;
  box-sizing: border-box;
  color: #e00b5b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  padding-left: 16px;
  padding-right: 16px;
  text-wrap: nowrap;
}
</style>
